var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.variant === "placeholder"
    ? _c(
        "div",
        {
          staticClass:
            "video-loading-overlay video-loading-overlay--placeholder",
        },
        [
          _c("div", { staticClass: "video-loading-overlay__spinner" }, [
            _c("div", {
              staticClass:
                "video-loading-overlay__spinner-icon video-loading-overlay__spinner-icon--md",
            }),
            _c("p", { staticClass: "video-loading-overlay__message" }, [
              _vm._v(_vm._s(_vm.displayMessage)),
            ]),
          ]),
        ]
      )
    : _vm.variant === "overlay"
    ? _c(
        "div",
        {
          staticClass: "video-loading-overlay video-loading-overlay--overlay",
          style: { zIndex: _vm.zIndex },
        },
        [
          _c("div", { staticClass: "video-loading-overlay__spinner" }, [
            _c("div", {
              staticClass:
                "video-loading-overlay__spinner-icon video-loading-overlay__spinner-icon--lg",
            }),
            _c("p", { staticClass: "video-loading-overlay__message" }, [
              _vm._v(_vm._s(_vm.displayMessage)),
            ]),
          ]),
        ]
      )
    : _vm.variant === "error-retry"
    ? _c(
        "div",
        {
          staticClass:
            "video-loading-overlay video-loading-overlay--error-retry",
          style: { zIndex: _vm.zIndex },
        },
        [
          _c("div", { staticClass: "video-loading-overlay__error-content" }, [
            _c("div", { staticClass: "video-loading-overlay__error-icon" }, [
              _vm._v(_vm._s(_vm.errorIcon)),
            ]),
            _c("p", { staticClass: "video-loading-overlay__error-title" }, [
              _vm._v(_vm._s(_vm.displayTitle)),
            ]),
            _c("p", { staticClass: "video-loading-overlay__error-message" }, [
              _vm._v(_vm._s(_vm.displayMessage)),
            ]),
            _vm._m(0),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "video-loading-overlay__retry-progress" }, [
      _c("div", {
        staticClass:
          "video-loading-overlay__spinner-icon video-loading-overlay__spinner-icon--sm",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }